import React from 'react'
import { observer } from 'mobx-react'
import { TableHeader, TableSortOrder } from 'components/Table'
import { DocumentManagementViewModel } from '../DocumentManagementViewModel'
import { StaticColumnDetails } from '../DocumentTableColumns'

interface DocumentManagementTableHeaderRowProps {
  vm: DocumentManagementViewModel
  getSortOrder?: (column: StaticColumnDetails) => TableSortOrder
  setSortOrder?: (
    column: StaticColumnDetails,
    direction: TableSortOrder,
  ) => void
}

export default observer(function DocumentManagementTableHeaderRow({
  vm,
  getSortOrder,
  setSortOrder,
}: DocumentManagementTableHeaderRowProps) {
  return (
    <>
      {vm.columns.map((col) => (
        <TableHeader
          key={col.id}
          canSort={col.sortable}
          align="left"
          sortOrder={getSortOrder && getSortOrder(col)}
          onSort={
            setSortOrder
              ? (newSort) => {
                  setSortOrder(col, newSort)
                }
              : undefined
          }
        >
          {col.header}
        </TableHeader>
      ))}
    </>
  )
})
